import {
  IAddress,
  IInfinitePageParams,
  IInfinitePageResponse,
} from 'services/types';

export interface ILabelMutationAddress extends IAddress {}
export interface ILabelMutationTaxOffice extends IAddress {
  name: string;
}

export interface ILabelMutation {
  labelStatus: LABEL_STATUS;
  labelName: string;
  email: string;
  phoneNumberPrefix: string;
  phoneNumber: string;
  customerType: CUSTOMER_TYPE;
  firstName: string;
  lastName: string;
  dateOfBirth: string | null;
  address: ILabelMutationAddress;
  taxOffice: ILabelMutationTaxOffice;
  bankAccountNumber: string;
  bankName: string;
  swift: string;
  personalIdCountryAlfa2: string;
  personalId: string;
  companyId: string;
  companyCountryAlfa2: string;
  legalSupervisorFirstName: string;
  legalSupervisorLastName: string;
  legalSupervisorCountryAlfa2: string;
  legalSupervisorPersonalId: string;
  notifyOnDocumentGeneration: boolean;
}

export interface ICreateLabel extends ILabelMutation {}

export interface IEditLabel extends ILabelMutation {
  id: string;
}

export interface ILabelResidenceCertificateMutation {
  LabelId: string;
  ResidenceCertificateCountryCodeAlfa2: string;
  ResidenceCertificateFile: File;
  ResidenceCertificateExpirationDate: string;
}

export interface ILabelForm extends ILabelMutation {
  residenceCertificates: ILabelResidenceCertificateResponse[];
  residenceCertificate?: ILabelResidenceCertificateMutation;
}

export interface IGetLabelListInfiniteParams extends IInfinitePageParams {
  labelName?: string;
  personalId?: string;
  companyId?: string;
  email?: string;
  status?: LABEL_STATUS;
}

export interface ILabelResidenceCertificateCountryResponse {
  polishName: string;
  englishName: string;
  codeAlfa2: string;
  codeAlfa3: string;
}

export interface ILabelResidenceCertificateVatTaxResponse {
  vatTax?: number;
  codeAlfa2: string;
}

export interface ILabelResidenceCertificateScanResponse {
  id: string;
  fileName: string;
  path: string;
  sizeInMB: number;
  createdAt: string;
  extension: string;
  mD5Hash: string;
}

export interface ILabelResidenceCertificateResponse {
  id: string;
  country: ILabelResidenceCertificateCountryResponse;
  countryVatTax?: ILabelResidenceCertificateVatTaxResponse;
  residenceScan: ILabelResidenceCertificateScanResponse;
  expirationDate: string;
}

export interface ILabelResponse {
  accountDetailsBankAccountNumber: string;
  accountDetailsBankName: string;
  accountDetailsSwift?: string;
  addressCity: string;
  addressCountry: string;
  addressFlatNumber: string;
  addressHouseNumber: string;
  addressStreet: string;
  addressZipCode: string;
  companyIdCompanyIdentification: string | null;
  companyIdCountry: string | null;
  createdAt: string | null;
  customerTypeId: CUSTOMER_TYPE;
  dateOfBirth: string;
  editedAt: string | null;
  email: string;
  firstName: string;
  id: string;
  accountId: string;
  isOfLegalAgeValue: string | null;
  labelName: string;
  labelStatus: LABEL_STATUS;
  lastName: string;
  legalSupervisorFirstName: string | null;
  legalSupervisorLastName: string | null;
  legalSupervisorPersonalId: string | null;
  legalSupervisorPersonalIdCountry: string | null;
  personalId: string;
  personalIdCountry: string;
  phoneNumberNumber: string;
  phoneNumberPrefix: string;
  taxOfficeAddressCity: string;
  taxOfficeAddressCountry: string;
  taxOfficeAddressFlatNumber: string;
  taxOfficeAddressHouseNumber: string;
  taxOfficeAddressStreet: string;
  taxOfficeAddressZipCode: string;
  taxOfficeName: string;
  notifyOnDocumentGeneration: boolean | null;
  residenceCertificates: ILabelResidenceCertificateResponse[];
  settlementMethodId: SETTLEMENT_METHOD | null;
  settlementMethodName: string | null;
}

export interface ILabelPageResponse extends IInfinitePageResponse<ILabelResponse> {}

export interface ILabelLight {
  id: string;
  labelName: string;
}

export enum CUSTOMER_TYPE {
  unknown = -1,
  Physical = 1,
  Company = 2,
}

export enum SETTLEMENT_METHOD {
  unknown = -1,
  greedy = 1,
  generous = 2,
  alwaysMoney = 3,
}

export interface ICheckSettlementPeriodsParams {
  labelId: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
}

export interface ICheckSettlementPeriodsResponse {
  hasOverlap: boolean;
  hasGap: boolean;
  labelReportOverlap: boolean;
}

export interface IUserAccount {
  length: number;
  labelName: string;
  id: string;
}

export interface SwitchAccountMutation {
  token: string;
  accountId: string;
}

export interface ISwitchAccountResponse {
  token: string;
  expires: number;
  refreshToken: string;
  refreshTokenExpires: number;

  require2FA: boolean;
  requireOTP: boolean;
  token2FA: string;
  token2FAExpires: number;
}

export enum LABEL_STATUS {
  unknown = -1,
  draft = 1,
  notVerified = 2,
  duringVerification = 3,
  verified = 4,
  banned = 5,
}
